import React, { useCallback, useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer, 
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Chip,
  PaginationItem,
  Tooltip,
} from "@mui/material";
import * as XLSX from "xlsx";
import {
  NoDataFoundRow,
  StyledTableCell,
  StyledTableRow,
} from "../../../components/common/StyledTableComponents";
import { useDispatch, useSelector } from "react-redux";
import { getdeleteduserslistApi } from "../../../features/Admin/Reports/AdminReports";
import dayjs from "dayjs";
import Loader from "../../../components/common/Loader/Loader";
import NormalDatePicker from "../../../components/common/NormalDatePicker";
import CustomSearchField from "../../../components/common/CustomSearchField";
import { debounce } from "lodash";
import ExportToExcelButton from "../../../components/common/ExportToExcelButton";
import RefreshButton from "../../../components/common/RefreshButton";
import { notifyError } from "../../../utils/notificationMsg";
import CustomPagination from "../../../components/common/CustomPagination";
import { applyCellStyles, generateColumnWidths } from "../../../components/common/ExcelFormatter";
import { exportToExcelAll } from "../../../components/common/ExportToExcel";
import { convertTimestampToDate } from "../../../utils/helpers";
const RecruterReports = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'year').toDate());;
  const [toDate, setToDate] = useState(dayjs().toDate());
  const [lodaing, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [Count, setCount] = useState(1);
  const [excelLogo, setExcelLogo] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  function formatDate(dateString) {
    if (!dateString) {
      return "Invalid Date"; // Handle case where dateString is undefined or invalid
    }

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Handle invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  const GetRecruiterReports = async (query = "", pageNum = 1  ,pageSize=rowsPerPage) => {
    setLoading(true);
    let data = {
      usertype: "recruiter",
      pagesize: pageSize,
      pagenumber: pageNum === 0 ? 1 : pageNum,
      searchitem: query,
      export: false,
    };
    try {
      const { payload } = await dispatch(getdeleteduserslistApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        console.log(payload.data ,"./././././");
        setCount(payload.totalRecords);
        setPage(pageNum);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const GetRecruiterReportsExport = async () => {
    setExcelLogo(true);
    let requestData = {
      usertype: "recruiter",
      pagenumber: 1,
      searchitem: "",
      export: true,
    };

    try {
      const { payload } = await dispatch(getdeleteduserslistApi(requestData));
      if (payload.status === 200) {
        let data = payload.data || [];
        if (data.length === 0) {
          notifyError("No data available for export");
          setExcelLogo(false);
          return;
        }
        exportToExcel(data);
      }
    } catch (err) {
      console.error(err);
      notifyError("Error: Unable to export data");
    } finally {
      setExcelLogo(false);
    }
  };
  const exportToExcel = (data) => {
    if (data.length === 0) {
      notifyError("Data not Avalable For Export");
      setExcelLogo(false);
      return;
    }

    try {
      const formattedData = data.map((row, index) => {
        const regDate =
          new Date(row.user_cdate?.$date).toLocaleDateString() || "N/A";
        const latestSubscription = row.user_subscription
          ? row.user_subscription.reduce((latest, current) => {
              return new Date(current.subscription_cdate.$date) >
                new Date(latest.subscription_cdate.$date)
                ? current
                : latest;
            })
          : null;
        return {
          No: index + 1,
          "Reg. Date": regDate,
          "Name of Recruiter": row.user_fullname || "N/A",
          Email: row.user_email || "N/A",
          "Contact No": row.user_mobileno || "N/A",
          Address: row.user_address ? row.user_address : "N/A",
          "Deleted Date": convertTimestampToDate(row.user_mdate.$date),
        };
      });
      exportToExcelAll(formattedData, "Deleted Recruiter", "Deleted Recruiter.xlsx");
     
    } catch (err) {
      console.error(err);
      setExcelLogo(false);
    } finally {
      setExcelLogo(false);
    }
  };
  const GetRecruiterReportsReset = async (from, to) => {
    setLoading(true);
    let data = {
      status: "recruiter",
      fromDate: formatDate(from),
      toDate: formatDate(to),
      pagenumber: 1,
      searchitem: "",
      export: false,
    };
    try {
      const { payload } = await dispatch(getdeleteduserslistApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const today = new Date();
  const handleFromDateChange = (date) => {
    setFromDate(date); // Update the from date
    // If the new from date is greater than the current to date, reset the to date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const getStatusChipColor = (status) => {
    switch (status.toLowerCase()) {
      case "active":
        return "success";

      case "blocked":
        return "error";
    }
  };
  const truncateText = (text, limit = 100) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };
  const handlePageChange = (value) => {
    setPage(value);
    GetRecruiterReports(searchQuery, value ,rowsPerPage);
  };
  const debouncedSearch = useCallback(
    debounce((query) => {
      GetRecruiterReports(query, 1, rowsPerPage);
    }, 1300),
    []
  );
  const handelSearchChange = (e) => {
    setSearchQuery(e.target.value);
    debouncedSearch(e.target.value, fromDate, toDate);
  };

  const reset = async () => {
    setSearchQuery("");
    let from = dayjs().startOf("month").toDate();
    let to = dayjs().toDate();
    setFromDate(from);
    setToDate(to);
    setTimeout(() => GetRecruiterReportsReset(from, to), 0);
    setPage(1);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setPage(1);
    setRowsPerPage(newRowsPerPage);
    GetRecruiterReports(searchQuery, 1,newRowsPerPage);
  };

  useEffect(() => {
    GetRecruiterReports();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          p: 3,
          borderRadius: "10px",
        }}
      >
        <Grid container spacing={2} alignItems="center" justifyContent={"end"}>
          <Grid item xs={12} md={8}>
          <Typography
          variant="body1"
          sx={{
            fontSize: "18px",
            lineHeight: "20px",
            textAlign: "left",
            color: "#250258",
          }}
        >
          {"Recruiters"}
        </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="flex-end"
            >
              <Grid item xs={8}>
                <CustomSearchField
                  searchQuery={searchQuery}
                  onChange={handelSearchChange}
                />
              </Grid>

              <Grid item xs={4}>
                <ExportToExcelButton
                  onClick={GetRecruiterReportsExport}
                  disabled={excelLogo}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
        <Box>
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#ECF1FF" }}>
                  <StyledTableCell>No.</StyledTableCell>
                  <StyledTableCell>Reg. Date</StyledTableCell>
                  <StyledTableCell>Name of Recruiter</StyledTableCell>
                  <StyledTableCell>Email</StyledTableCell>
                  <StyledTableCell>Contact No.</StyledTableCell>
                  <StyledTableCell>Address</StyledTableCell>
                  <StyledTableCell>Deleted Date</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  data.map((row, index) => {
                    const regDate = row.user_cdate.$date;
                    const chipColor = getStatusChipColor(row.user_status);
                    const latestSubscription = row.user_subscription
                      ? row.user_subscription.reduce((latest, current) => {
                          return new Date(current.subscription_cdate.$date) >
                            new Date(latest.subscription_cdate.$date)
                            ? current
                            : latest;
                        })
                      : null;
                    const lastPaymentDate = latestSubscription
                      ? new Date(
                          latestSubscription.subscription_cdate.$date
                        ).toLocaleDateString()
                      : "N/A";

                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        <StyledTableRow sx={{ textAlign: "center" }}>
                          {(page - 1) * 10 + index + 1}.
                        </StyledTableRow>
                        <StyledTableRow sx={{ minWidth: "130px" }}>
                          {convertTimestampToDate(regDate)}
                        </StyledTableRow>
                        <StyledTableRow>{row.user_fullname}</StyledTableRow>

                        <StyledTableRow>{row.user_email}</StyledTableRow>
                        <StyledTableRow style={{ whiteSpace: 'nowrap' }}>
                          {row.user_mobileno}
                        </StyledTableRow>

                        <StyledTableRow sx={{ minWidth: "250px" }}>
                          {truncateText(row.user_address, 50)}{" "}
                        </StyledTableRow> 
                        <StyledTableRow sx={{ minWidth: "130px" }}>
                          {convertTimestampToDate(row.user_mdate.$date)}
                        </StyledTableRow>
                      </TableRow>
                    );
                  })
                ) : (
                  <NoDataFoundRow
                    colSpan={9}
                    message={` Recruiters Are Not Available!`}
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {data?.length > 0 && (
           <CustomPagination
           totalRecords={Count}
           rowsPerPageOptions={[10, 25, 50, 100]}
           initialRowsPerPage={rowsPerPage}
           setRowsPerPage1={setRowsPerPage}
           initialPage={page - 1}
           onPageChange={handlePageChange}
           onRowsPerPageChange={handleRowsPerPageChange}
         />
          )}
        </Box>
    </>
  );
};

export default RecruterReports;
